<template>
  <div class="email-wrapper">
    <label
        :class="['email-subject-label', { ['error-label']: errors.subject }]"
        name="email_subject">
      email subject
    </label>
    <input
        v-model="emailSubject"
        rows="5"
        type="text"
        name="email_subject"
        class="email-subject"
        @change="subjectUpdate"
        @blur="initSubjectInteraction" />
    <span
        v-if="errors.subject"
        class="error-label error-message">
      {{errors.subject}}
    </span>
    <label
        :class="['email-message', { ['error-label']: errors.content }]"
        name="email_message">
      email message
    </label>
    <text-editor
        v-show="emailSend"
        :key="'email'+campaignId"
        :campaignId="campaignId"
        canInsertImages
        :editorContent="emailContent"
        editorExtraClasses="email-editor"
        showToolbar
        toolbarClass="email-toolbar"
        @setEditor="setEditor"
        @setEditorContent="setEmailContent">
    </text-editor>
    <span
        v-if="errors.content"
        class="error-label error-message">
      {{errors.content}}
    </span>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import TextEditor from '../QuillTools/TextEditor'

  export default {
    props: {
      email: Object,
      emailSend: Boolean,
      isInView: Boolean,
    },

    name: 'CampaignEmail',

    components: {
      TextEditor,
    },

    data() {
      return {
        emailContent: '',
        emailSubject: '',
        editor: null,
        errors: {
          content: null,
          subject: null,
        },
        noInteraction: {
          content: true,
          subject: true,
        },
        showContentError: false,
        showSubjectError: false,
        validEmail: null,
      }
    },

    methods: {
      initSubjectInteraction() {
        if (this.noInteraction['subject']) {
          this.$set(this.noInteraction, 'subject', false)
          this.updateEmailInteraction()
          this.validateSubject()
        }
      },

      setEditor(editor) {
        this.editor = editor
      },

      setEmailContent(emailContent) {
        this.emailContent = emailContent
        this.validateContent()
        !this.errors.content &&  this.updateEmail(this.emailContent, null)
      },

      subjectUpdate() {
        this.validateSubject()
        if (!this.errors.subject) { this.updateEmail(null, this.emailSubject) }
      },

      updateEmail(emailContent, emailSubject) {
        let email = emailContent ? { email_content: emailContent } : { email_subject:  emailSubject }
        this.$emit('updateEmail', email)
      },

      updateEmailInteraction() {
        let noInteraction = this.noUserInteraction ? { email: true } : {}
        if (!this.emailSend) { noInteraction = {} }
        this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey: 'email', itemObject: noInteraction})
      },

      validateContent() {
        this.noInteraction.content && this.$set(this.noInteraction, 'content', false)
        const emailText = this.emailContent,
          contentError = emailText.length < 12 ? 'email needs to be at least several characters' : null
        this.$set(this.errors, 'content', contentError)
        this.validateEmail()
      },

      validateEmail() {
        this.validEmail = !this.errors.content && !this.errors.subject
        const validObject = this.validEmail || !this.emailSend ? {} : { emailValid: this.validEmail }
        this.UPDATE_STATE_OBJECT({itemKey: 'email', itemObject: validObject})
      },

      validateSubject() {
        if (!this.emailSubject || this.emailSubject.length < 1) {
          this.$set(this.errors, 'subject', 'email subject cannot be empty')
        } else if (this.emailSubject.length > 255) {
          this.$set(this.errors, 'subject', 'email subject cannot be over 255 characters')
        } else {
          this.$set(this.errors, 'subject', null)
        }
        this.validateEmail()
      },

      ...mapActions({
        UPDATE_STATE_OBJECT: 'UPDATE_STATE_OBJECT'
      })
    },

    created() {
      if (this.email) {
        this.emailSubject = this.email.subject
        this.emailContent = this.email.content
        this.emailSubject && this.$set(this.noInteraction, 'subject', false)
        this.emailContent && this.$set(this.noInteraction, 'content', false)
      }
      if (this.emailSend) { this.updateEmailInteraction() }
    },

    computed: {
      noUserInteraction: function () {
        return !!this.noInteraction.content || !!this.noInteraction.subject
      },

      ...mapState({
        campaignId: state => state.message.messageId
      }),
    },

    watch: {
      emailSend: function () {
        this.emailSend && this.updateEmailInteraction()
        !this.emailSend && this.UPDATE_STATE_OBJECT({stateKey: 'noUserInteractions', itemKey: 'email', itemObject: {}})
      },

      noUserInteraction: function () {
        this.updateEmailInteraction()
      }
    }
  }
</script>